import { retryPromise } from '../helpers/retryPromise';

async function getLocationCode(latitude: number, longitude: number): Promise<string> {
    const locationCodeFetchURL = `${import.meta.env.VITE_BASE_URL}${import.meta.env.VITE_PVWATTS_LOCATION_CODE_URL}?Lat=${latitude}&Lon=${longitude}`;

    const response: any = await retryPromise<Response>(async () => {
        const response = await fetch(locationCodeFetchURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        if (!response.ok) {
            throw new Error(response.toString());
        }

        return response;
    }, {
        retries: 10,
        factor: 2,
        minTimeout: 200,
        maxTimeout: 60 * 1000,
        randomize: true
    });

    const json = await response.json();
    return json['LocationCode'];
}

export default getLocationCode;
